import React from 'react';
import { Target } from 'lucide-react';
import ChatGPTEntityTable from './ChatGPTEntityTable';

/**
 * Tableau des groupes d'annonces ChatGPT Ads.
 *
 * Préréglage de `ChatGPTEntityTable`, qui porte tout le comportement — tri, pagination,
 * colonnes configurables, appariement à la période précédente. Ce fichier ne nomme que ce
 * qui distingue les groupes des annonces, et garde les noms de props historiques
 * (`adGroups`, `previousAdGroups`) pour que l'appelant n'ait rien à changer.
 */
const ChatGPTAdGroupsTable = ({ adGroups = [], previousAdGroups = null, ...reste }) => (
  <ChatGPTEntityTable
    lignes={adGroups}
    lignesPrecedentes={previousAdGroups}
    titre="Groupes d'annonces"
    intituleColonne="Groupe d'annonces"
    icone={Target}
    classeSuffixe="ad-groups"
    moduleId="chatgpt_ad_groups"
    {...reste}
  />
);

export default ChatGPTAdGroupsTable;
